/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


$(function() {
  var consent = Cookies.get('wa-consent');
  
  if( consent === undefined || consent === 'n' || consent === null ) {
    $('.cookie-box').addClass('show-cookie');
  }
  
  $('.cookie-box__accept a').click(function(e){
    e.preventDefault();
    
    $('.cookie-box').fadeOut();
    
    Cookies.set('wa-consent', 'y', {expires: 7});
    
  })
  
  $(document).on('click', '.CollectionFilters button:not(.Heading), .Link--primary', function() {
    loading = false;
    let url = window.location.href;
    let splitUrl = url.split('.com/');
    let splitUrlTwo = splitUrl[1].split('?');
    $('.ProductList').attr('data-next-url', "/" + splitUrlTwo[0] + "?page=2&" + splitUrlTwo[1]);
    nextUrl = "/" + splitUrlTwo[0] + "?page=2&" + splitUrlTwo[1];
  });

  $(document).on('click', '.promotion-code-wrapper .Cart__Promocode', function() {
    $(this).parent().toggleClass('active');
  });
  $(document).on('click', '.Cart__NoteButton', function() {
    $(this).parent().toggleClass('active');
  });
  $(document).on('click', '.Cart__Gift_Trigger', function() {
    $(this).parent().toggleClass('active');
  });

  if (jQuery('.ymal-products-section').length > 0 && jQuery('.ymal-products-section .Grid__Cell').length < 4) {
    cartRecommendedProducts();
  }

  // Collection filters signposting
  if ($('.signpost_filter').length > 0) {
    // Check if any CTA should be highlighted
    $('.Linklist__Checkbox:checked').each(function() {
      $('.signpost_filter[href="?' + $(this).attr('name') + '=' + escape($(this).attr('value').replaceAll(' ', '+')) + '"]').addClass('is-active');
      
    });

    // Check prices
    var priceGT = $('#filter-v-price-gte').val();
    var priceLT = $('#filter-v-price-lte').val();
    $('.signpost_filter[href="?filter.v.price.gte=' + priceGT + '&filter.v.price.lte=' + priceLT + '"]').addClass('is-active');

    $('.signpost_filter').each(function(){
      $(this).on('click', function(e){
        e.preventDefault();

        //$(this).toggleClass('is-active');

        var filterCTA = $(this).attr('href').replace('?', '').replaceAll('+', ' ').split('=');
        filterCTAName = filterCTA[0];
        filterCTAValue = unescape(filterCTA[1]);
        if ($('.CollectionToolbar__Item--filter:visible').length > 0) {
          $('.Drawer__Content input[name="' + filterCTAName + '"][value="' + filterCTAValue + '"]').trigger('click');
          $('.Drawer__Footer input[name="' + filterCTAName + '"][value="' + filterCTAValue + '"]').trigger('click');
        }

        // Price CTA
        if ($(this).attr('href').includes('filter.v.price.gte')) {
          var min = $('#filter-v-price-gte').attr('min');
          var max = $('#filter-v-price-lte').attr('max');
          var filterPrices = $(this).attr('href').replace('?', '').split('&');
          var filterPricesGT = filterPrices[0].split('=');
          var filterPricesLT = filterPrices[1].split('=');

          if ($(this).hasClass('is-active')) { //Reset prices filter
            (document).querySelector('.price-range__input:first-child input').value = min;
            (document).querySelector('.price-range__input:first-child input').max = max;

            (document).querySelector('.price-range__input:last-child input').value = max;
            (document).querySelector('.price-range__input:last-child input').min = min;
          } else { //Set prices range
            if(filterPricesGT[1] == '') {
              filterPricesGT[1] = min;
            }
            if(filterPricesLT[1] == '') {
              filterPricesLT[1] = max;
            }
            (document).querySelector('.price-range__input:first-child input').value = filterPricesGT[1];
            (document).querySelector('.price-range__input:first-child input').max = filterPricesLT[1];

            (document).querySelector('.price-range__input:last-child input').value = filterPricesLT[1];
            (document).querySelector('.price-range__input:last-child input').min = filterPricesLT[1];
          }

          (document).querySelector('.price-range__input:first-child input').dispatchEvent(new Event('change', {
            bubbles: true
          }));
        }

        return false;
      });
    });

    $('body').on('click', '.Drawer__Content input', function() {
      $('.signpost_filter').removeClass('is-active');
      $('.Linklist__Checkbox:checked').each(function(){
        $('.signpost_filter[href="?' + $(this).attr('name') + '=' + escape($(this).attr('value').replaceAll(' ', '+')) + '"]').addClass('is-active');
      });

      //Check price fields
      var priceGT = $('#filter-v-price-gte').val();
      var priceLT = $('#filter-v-price-lte').val();
      $('.signpost_filter[href="?filter.v.price.gte=' + priceGT + '&filter.v.price.lte=' + priceLT + '"]').addClass('is-active');
    });

    $('body').on('change', '.price-range__input input', function() {
      $('.signpost_filter').removeClass('is-active');
      $('.Linklist__Checkbox:checked').each(function(){
        $('.signpost_filter[href="?' + $(this).attr('name') + '=' + escape($(this).attr('value').replaceAll(' ', '+')) + '"]').addClass('is-active');
      });

      //Check price fields
      var priceGT = $('#filter-v-price-gte').val();
      var priceLT = $('#filter-v-price-lte').val();
      $('.signpost_filter[href="?filter.v.price.gte=' + priceGT + '&filter.v.price.lte=' + priceLT + '"]').addClass('is-active');
    });
  }
  
  // Product page - scroll to the breadcrumb on load
  if ($('.pt-form-product-special-name-and-title-container').length > 0 && $(window).width() > 1024) {
    var headerHeight = $('#section-header').outerHeight();
    console.log(headerHeight);
    console.log($('#shopify-section-product-template').offset().top);
    $([document.documentElement, document.body]).animate({
      scrollTop: $('#shopify-section-product-template').offset().top - headerHeight
    }, 200);

    $('.pt-form-accordion-list-item:visible .pt-form-accordion-list-item-heading').first().click();
  }

  if ($(".pt_add__card").length > 0) {
    $(".pt_add__card").each(function() {
      var product_data_url = $(this).data('product_src') + '.json';
      var upsell_el = $(this);
      var params = {
        type: 'GET',
        url: product_data_url,
        dataType: 'json',
        success: function(upsell) {
          upsell_el.attr('data-variant-id', upsell.product.variants[0].id);
          upsell_el.find('img').attr('src', upsell.product.image.src.replace('.jpg', '_125x.jpg').replace('.png', '_125x.png'));
          upsell_el.find('.pt_add__card__title p').text(upsell.product.title);

          switch (window.theme.shopCurrency) {
            case 'GBP':
              var currency_icon = '£';
              break;
            case 'USD':
                var currency_icon = '$';
              break;
            default:
              break;
          }

          upsell_el.find('.pt_add__card__price p').text(currency_icon + upsell.product.variants[0].price);
        }
      };

      $.ajax(params);
    });
  }

  if ($('.sticky-add-to-cart').length > 0) {
    
    if ($('.ProductForm__AddToCart[data-action="add-to-cart"]').length) {
      $('.sticky-add-to-cart .Button--text').html($('.ProductForm__AddToCart[data-action="add-to-cart"]').html());
    } else if ($('.ProductForm__AddToCart[disabled]').length ) {
      $('.sticky-add-to-cart .Button--text').html($('.ProductForm__AddToCart').html());
      $('.sticky-add-to-cart .Button').removeClass('Button--primary').addClass('Button Button--secondary Button--full').attr('disabled','disabled');
    }

    var offset = 86;
    if ($(window).width() < 640) {
      offset = 0;
    }
      if ($('.ProductForm__BuyButtons').offset().top < $(window).scrollTop() + offset ) {
        $('.sticky-add-to-cart').removeClass('hide').addClass('show');
      } else {
        $('.sticky-add-to-cart').removeClass('show').addClass('hide');
      }

    $(window).on('scroll resize', function(){
      var offset = 86;
      if ($(window).width() < 640) {
        offset = 0;
      }
      if ($('.ProductForm__BuyButtons').offset().top < $(window).scrollTop() + offset ) {
        $('.sticky-add-to-cart').removeClass('hide').addClass('show');
      } else {
        $('.sticky-add-to-cart').removeClass('show').addClass('hide');
      }

      $('.ProductForm__BuyButtons').addClass('show');
    });

    $('body').on('click', '.sticky-add-to-cart .Button', function(){
      if ( $('.ProductForm__AddToCart.bold_clone').length > 0 ) {
        $('.ProductForm__AddToCart.bold_clone').click();
      } else {
        $('.ProductForm__AddToCart').click();
      }
    });

    // Check if BoldOptions returned error
    $('.bold_options').on('DOMSubtreeModified', function(){
      if( $('.bold_error_message').length > 0 ) {
        window.scrollTo({
          top: $('.bold_error_message:eq(0)').offset().top - 150,
          left: 0,
          behavior: 'smooth'
        });
      }
    });

    if ($(window).scrollTop() > 0) {
      $('.ProductForm__BuyButtons').addClass('show');
    }
  }

  if ( $('.product-description-delivery-tabs').length > 0 ) {
    $('.product-description-delivery-tabs a').on('click', function(e) {
      e.preventDefault();

      $('.product-description-delivery-tabs a').removeClass('active');
      $(this).addClass('active');
      let tab_name = $(this).attr('href');

      $('.ProductMeta__Description_Tab').hide();
      $(tab_name).show();

      return false;
    })
  }

  // Poll the product carousel item heights
  const funcCHeckProductCarouselMinHeight = () => {
    const elProductCarousels = document.querySelectorAll('.ProductList.ProductList--carousel');
    const mqMatchMedia = window.matchMedia('(max-width:767px)');
    [...elProductCarousels]
      .forEach(elCarousel => {
        const elSlides = elCarousel.querySelectorAll('.Carousel__Cell');

        let maxHeight = 0;
        elCarousel.style.setProperty('--min-cell-height', `${maxHeight}px`);

        if (mqMatchMedia.matches) {
          [...elSlides]
            .forEach(elSlide => {
              if (parseInt(elSlide.offsetHeight, 10) > maxHeight) {
                maxHeight = parseInt(elSlide.offsetHeight, 10);
              }
            });

          elCarousel.style.setProperty('--min-cell-height', `${maxHeight}px`);
        }
      });
  };

  funcCHeckProductCarouselMinHeight();

  setInterval(funcCHeckProductCarouselMinHeight, 2000);
});

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  console.log('var - ', variant);
  if (!variant || !variant['featured_image']) {
    return;
  }
  $('div[data-media-id=' + variant['featured_image']['id'] + ']').trigger('click');

  variantsObj.forEach(function(el){
    if (el.id == variant.id) {
      if (el.inventory_qty >= 1 && el.inventory_qty <= 5) {
        $('.pt-inventory-inner').html('<div class="pt-inventory">Only ' + el.inventory_qty + ' in stock</div>');
      } else {
        $('.pt-inventory-inner').html('');
      }
    }
  });

  //$('.ProductForm__AddToCart[data-money-convertible]').addClass('bold_option_price_display')
  //console.log('ProductForm__AddToCart', $('.ProductForm__AddToCart[data-money-convertible]').text());

});

document.addEventListener('theme:loading:end', function(event) {
  window.webyzeMultiProductColorsLoad(),console.log('webyse sent')
});

// $(window).on('load', function () {
//   var f = $('#frame').contents().find('#data');
//   console.log(f);
//   let noReviews = $('#trustBoxCheck').attr('data-no-reviews');
//   if (noReviews == 'show') {
//     $('#trustBoxCheck').find('iframe').height(120);
//   }
// });

function cartRecommendedProducts() {
  // Create an AJAX request
  var request = new XMLHttpRequest();
  var baseURL = jQuery('.ymal-products-section').data('baseurl');
  var lastProductID = jQuery('.CartItem:last-child').data('product-id');

  console.log(baseURL + ".json?product_id=" + lastProductID + "&limit=4");

  request.open(
      "GET",
      baseURL + ".json?product_id=" + lastProductID + "&limit=8"
  );

  request.onload = function () {
    if (request.status === 404 || request.status === 422) {
      return false;
    }

    var products = JSON.parse(request.response).products;

    if (products.length === 0) {
      return false;
    }

    // Append product recommendations to the DOM.
    var autoRecommendedProductsHTML = products.map(function (product) { return renderProduct(product) }).join("");
    jQuery('.ymal-products-section .CollectionListNew').append(autoRecommendedProductsHTML);

    window.dispatchEvent(new Event('resize'));
  };

  request.onerror = function () {
    return false;
  };

  // Send AJAX request
  request.send();
}

function renderProduct(product) {
  if (product.title.toLowerCase().includes('gift') || !product.available || product.price == 0 || product.tags.includes('OPTIONS_HIDDEN_PRODUCT') || product.tags.includes('BOLD_HIDDEN_PRODUCT') ) {
    return false;
  }

  var featured_image = '<img class="ProductItem__Image Image--lazyLoad Image--fadeIn" data-src="' + product.featured_image + '" data-widths="[200,400,600,700,800,900,1000,1200]" data-sizes="auto" alt="' + product.title + '">';
  var alt_image = '';
  var has_alt_image_class = '';
  if (product.images[1] != undefined) {
    alt_image = '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" data-src="' + product.images[1] + '" data-widths="[200,300,400,600,800,900,1000,1200]" data-sizes="auto" alt="' + product.title + '">';
    has_alt_image_class= 'ProductItem__ImageWrapper--withAlternateImage';
  }
  return [
    '<div class="Grid__Cell 1/2--phone 1/2--tablet-and-up 1/4--desk"><div class="ProductItem">',
    '<div class="ProductItem__Wrapper"><a href="' + product.url + '" class="ProductItem__ImageWrapper ' + has_alt_image_class + '">',
      '<div class="AspectRatio AspectRatio--withFallback" style="max-width: 1929px; padding-bottom: 100.0%; --aspect-ratio: 1.0">',
        alt_image,
        featured_image,
        '<span class="Image__Loader"></span>',
      '</div></a>',
      '<div class="ProductItem__Info ProductItem__Info--center"><h2 class="ProductItem__Title Heading">',
        '<a href="' + product.url + '">' + product.title + '</a></h2>',
        '<div class="ProductItem__PriceList  Heading"><span class="ProductItem__Price Price Text--subdued" data-money-convertible="">£' + Math.round(product.price) / 100 + '</span></div></div>',
        '<div class="webyze-multi-product-colors" data-product-id="' + product.id + '"></div></div></div></div>'
  ].join("");
}